module.exports = __webpack_public_path__ + "static/chara-a3e303b0f0443e1bfbf57b99a42edfd1.png";